import React from 'react'
export const Navbar = () => {
    return (
        <>
            <header className="header_main">
                <div className="header_nav">
                    <a href="#">

                    <div className="header_logos">
                   
                        <img src='./assets/img/colraices.png' alt="Colraices Comprar casa en colombia desde el exterior" />
                        <img src="./assets/img/davivienda.png" alt="" />
                    
                    </div>
                    </a>
                    <nav className="header_links ">
                        <ul>
                            <li><a href="#leasing">¿Qué es el leasing habitacional?</a></li>
                            <li><a href="#vivienda-vis">Vivienda VIS</a></li>
                            <li><a href="#vivienda-novis">Vivienda No VIS</a></li>
                        </ul>
                    </nav>
                </div>
                <button className="header_btn widget">
                    ¡Escríbenos!
                </button>
            </header>
        </>
    )
}
